import Vue from 'vue';
import { common, baseComponents } from '@tencent/ceiba-base-components';
// 使命召唤手游 角色信息 兼容
function adapterRoleInfo(roleList) {
  if (!roleList || roleList.length < 1) return null;
  const gid = Vue.prototype.$actInfo?.gid || '';
  if (`${gid}` === '1342') {
    if (common.tool.getQueryparams('openid') === roleList[0].role_id) {
      return roleList[0];
    }
  }
  return null;
}
export default class LoginGame {
  constructor() {
    this.tokenPart = '';
    this.msdkType = 'msdkv5';
  }
  async initLogin() {
    console.log('LoginGame initLogin');
    // MSDKV3登录态处理
    try {
      if (/msdkEncodeParam/.test(location.search)) {
        this.tokenPart = location.search;
        this.msdkType = 'msdkv3';
      }

      const expressItopen = new RegExp('itopencodeparam');
      // MSDKV5登录态处理
      if (expressItopen.test(location.search)) {
        this.tokenPart = location.search;
        this.msdkType = 'msdkv5';
      }
      const source = common.tool.getQueryparams('source');
      if (source !== null) {
        this.tokenPart = this.tokenPart.replace(`&source=${source}`, '').replace(`source=${source}&`, '');
      }
      console.log(`LoginGame initLogin|tokenPart=${this.tokenPart}|msdkType=${this.msdkType}`);
    } catch (e) {
      console.error('LoginGame initLogin fail|e=', e);
    }
  }
  async login(params) {
    console.log('LoginGame login|param=', params);
  }
  async checkLogin(params) {
    console.log('LoginGame checkLogin|param=', params);

    const appid = common.tool.getQueryparams('appid');
    const openid = common.tool.getQueryparams('openid');
    const acctype = common.tool.getQueryparams('acctype');
    const accessToken = common.tool.getQueryparams('access_token');
    const platid = common.tool.getQueryparams('platid') || common.tool.getQueryparams('sPlatId');

    const ceibaGameInfo = {};
    if (appid && openid && acctype && accessToken && platid) {
      // 写cookie
      // const cookies = `appid=;openid=3086137608;acctype=qq;access_token=@ZrbIlXNOI`;
      let changeAcctype = acctype;
      if (acctype === 'qq' && accessToken.length > 10) changeAcctype = 'qc';
      if (acctype === 'weixin') changeAcctype = 'wx';
      const cookies = `appid=${appid};openid=${openid};acctype=${changeAcctype};access_token=${accessToken}`;
      console.log('default url pass cookie=', cookies);
      common.tool.clearCookie('acctype'); // 清除下当前域下现有登录态
      console.log('clearCookie cookie acctype');

      common.tool.setCookies(cookies);

      const partition = common.tool.getQueryparams('partition') || common.tool.getQueryparams('partitionid') || common.tool.getQueryparams('partition_id') || common.tool.getQueryparams('partitionId') || common.tool.getQueryparams('sPartition') || common.tool.getQueryparams('sPartitionId') || common.tool.getQueryparams('p_partitionid');
      const roleid = common.tool.getQueryparams('role') || common.tool.getQueryparams('roleid') || common.tool.getQueryparams('role_id') || common.tool.getQueryparams('roleId') || common.tool.getQueryparams('sRole') || common.tool.getQueryparams('sRoleId') || common.tool.getQueryparams('charac_no') || common.tool.getQueryparams('p_roleid');
      const areaid = common.tool.getQueryparams('area') || common.tool.getQueryparams('areaid') || common.tool.getQueryparams('area_id') || common.tool.getQueryparams('areaId') || common.tool.getQueryparams('sArea') || common.tool.getQueryparams('sAreaId') || common.tool.getQueryparams('p_areaid');

      ceibaGameInfo.plat_id = parseInt(platid || '0', 10);
      ceibaGameInfo.partition_id = parseInt(partition || '0', 10);
      ceibaGameInfo.role_id = roleid;
      ceibaGameInfo.area_id = parseInt(areaid || '0', 10);
      ceibaGameInfo.device = common.platform.device;
    } else {
      // 去后端拿登录态，种到cookie，获取用户信息
      const response = await Vue.prototype.$axiosInstance.post('getAccessTokenByMSDK', {}, {
        headers: {
          'T-MODE': 'true',
          'T-OPENID': '',
          'T-APPID': '',
          'T-ACCESS-TOKEN': this.tokenPart,
          'T-ACCOUNT-TYPE': this.msdkType,
        },
      });
      console.log('getAccessTokenByMSDK response=', response);
      if (response.ret) {
        // 失败
        Vue.prototype.alert('系统繁忙，请刷新页面重试');
        // 登录失败也要上报 pv
        window.ceibaReporter?.enterPage(window.ceibaPvConfig);
        return { isLogin: false, userInfo: {} };
      }
      // 写cookie
      const cookies = `appid=${response['t-appid']};openid=${response['t-openid']};acctype=${response['t-account-type']};access_token=${response['t-access-token']}`;
      console.log('msdk url pass cookie=', cookies);

      common.tool.clearAllCookie(); // 清除下当前域下现有登录态
      common.tool.setCookies(cookies);

      // todo 优化写法 字段worldid: 兼容黎明觉醒大区参数
      const partition = common.tool.getQueryparams('partition') || common.tool.getQueryparams('partitionid') || common.tool.getQueryparams('partition_id') || common.tool.getQueryparams('partitionId') || common.tool.getQueryparams('sPartition') || common.tool.getQueryparams('sPartitionId') || common.tool.getQueryparams('worldid') || common.tool.getQueryparams('p_partitionid');
      const roleid = common.tool.getQueryparams('roleid') || common.tool.getQueryparams('role_id') || common.tool.getQueryparams('roleId') || common.tool.getQueryparams('sRole') || common.tool.getQueryparams('sRoleId') || common.tool.getQueryparams('charac_no') || common.tool.getQueryparams('role') || common.tool.getQueryparams('p_roleid');
      const areaid = common.tool.getQueryparams('area') || common.tool.getQueryparams('areaid') || common.tool.getQueryparams('area_id') || common.tool.getQueryparams('areaId') || common.tool.getQueryparams('sArea') || common.tool.getQueryparams('sAreaId') || common.tool.getQueryparams('p_areaid');

      ceibaGameInfo.plat_id = parseInt(response['t-platid'] || '0', 10);
      ceibaGameInfo.partition_id = parseInt(partition || '0', 10);
      ceibaGameInfo.role_id = roleid;
      ceibaGameInfo.area_id = parseInt(areaid || '0', 10);
      ceibaGameInfo.device = common.platform.device;
    }
    const userInfo = {
      loginType: this.msdkType,
      nickName: common.tool.getQueryparams('nickName') || common.tool.getQueryparams('nickname') || '当前游戏账户',
      avatar: common.tool.getQueryparams('avatar') || '',
    };
    console.log('ceibaGameInfo=', ceibaGameInfo);
    // 在写入 cookie 之后上报 pvuv
    window.ceibaReporter?.enterPage(window.ceibaPvConfig);
    // 由于有存在单区服游戏，这时候还是需要去查下游戏角色列表
    // // 直接返回已登录
    // if (!ceibaGameInfo.role_id) {
    //   return { isLogin: false, userInfo };
    // }
    // 拿下游戏角色
    try {
      const res = await baseComponents.Apis.Role.fetch({
        game_code: Vue.prototype.$actInfo.game_code,
        partition_id: ceibaGameInfo.partition_id,
        device: common.platform.device,
      });

      if (res.ret !== 0) {
        Vue.prototype.alert(res.msg ? res.msg : '获取游戏内角色异常');
        return { isLogin: false, userInfo: {} };
      }
      const roleList = res.roles;
      console.log('fetch roleList = ', roleList);
      let roleInfo = roleList.find((e) => {
        if (e.role_id === ceibaGameInfo.role_id) return true;

        if (e.game_open_id === e.role_id) return true;
        if (e.game_open_id === decodeURI(e.role_id)) return true;

        return false;
      });

      // 由于有存在单区服游戏，如果角色列表里只有一个角色，就直接取角色列表里的第一个角色
      if (roleList.length === 1) {
        const [firstRoleInfo] = roleList;
        roleInfo = firstRoleInfo;
      }

      console.log('adapter roleInfo before =', roleInfo);
      if (!roleInfo) {
        roleInfo = adapterRoleInfo(roleList);
        console.log('adapter roleInfo after =', roleInfo);
      }

      if (roleInfo) {
        console.log('fetch current roleInfo=', roleInfo, common.tool.Base64.decode(roleInfo.partition_name), common.tool.Base64.decode(roleInfo.role_name));
        ceibaGameInfo.game_open_id = roleInfo.game_open_id;
        ceibaGameInfo.game_app_id = roleInfo.game_app_id;
        ceibaGameInfo.partition_name = roleInfo.partition_name;
        ceibaGameInfo.partition_id = roleInfo.partition_id;
        ceibaGameInfo.role_name = roleInfo.role_name;
        ceibaGameInfo.role_id = roleInfo.role_id;
        ceibaGameInfo.device = roleInfo.device;
        ceibaGameInfo.plat_id = roleInfo.plat_id;
        ceibaGameInfo.area_id = roleInfo.area_id;

        sessionStorage.ceibaGameInfo = JSON.stringify(ceibaGameInfo);
        console.log('sessionStorage.ceibaGameInfo=', sessionStorage.ceibaGameInfo);
        return { isLogin: true, userInfo };
      }
      console.log('fetch current roleInfo nil');
      return { isLogin: false, userInfo: {} };
    } catch (e) {
      console.log('fetch roleList fail, e=', e);
      if (e.data?.msg) {
        Vue.prototype.alert(e.data?.msg);
      } else {
        Vue.prototype.alert('获取游戏内角色失败');
      }
      return { isLogin: false, userInfo: {} };
    }
  }
  async logout(params) {
    console.log('LoginGame logout|param=', params);
  }
}
